import * as BABYLON from 'babylonjs';
import * as BABYLONGUI from 'babylonjs-gui';
import PanoViewer from './PointViewer';
import XmlLoader2 from './XmlLoader2';
import ViewerStore from '../../stores/ViewerStore';
import * as Inovx from '@shared';
import ViewerActions from '../../actions/ViewerActions';
interface IPickResult {
    point: BABYLON.Vector3,
    valid: boolean
}

class PointCloudManager {

    private _pointClouds: { [sliceKey: string]: BABYLON.PointsCloudSystem; } = {};
    private _pointCloudMetadata: I360ScanData;

    public get pointClouds() { return this._pointClouds; }

    constructor(pointCloudMetadata: I360ScanData) {
        this._pointCloudMetadata = pointCloudMetadata;
    }

    public dispose() {
        this.clearPointClouds();
    }

    public clearPointClouds() {

        var pointClouds = Object.values(this._pointClouds);
        for (var i = 0; i < pointClouds.length; i++) {
            pointClouds[i].mesh.dispose();
            pointClouds[i].mesh = null;
            pointClouds[i].dispose();
            pointClouds[i] = null;
        }

        this._pointClouds = {};
    }
    public addPointCloud(key:string, pointCloud: BABYLON.PointsCloudSystem) {

        this._pointClouds[key] = pointCloud;
    }

    public enableSeenPointClouds(camera: BABYLON.Camera) {

        for (let i = 0; i < this._pointCloudMetadata.ScanDatas.length; i++) {
            var data = this._pointCloudMetadata.ScanDatas[i];

            if (data == null)
                continue;

            var val = data.SliceIndex + (data.IsNearSlice ? "near" : "far");
            if (this._pointClouds[val] == null)
                continue;

            if (this.isMeshInFrustum(this._pointClouds[val].mesh, camera)) {
                this._pointClouds[val].mesh.setEnabled(true);
            } else {
                this._pointClouds[val].mesh.setEnabled(false);
            }
        }
    }

    public pickPointCloud(screenPoint: BABYLON.Vector2, scene: BABYLON.Scene, pickTolerance: number): IPickResult {

        var superCloseList: BABYLON.Vector3[] = [];
        var closeTolerance = pickTolerance * .1;
        var xPoint = screenPoint.x;
        var yPoint = screenPoint.y;
        var cam = scene.activeCamera as any;

        // Create the frustum of the 2 D box projected into 3d space.
        var ray = scene.createPickingRay(xPoint, yPoint, null, cam);
        var meshPick = scene.pick(xPoint, yPoint);
        var pointClouds = Object.values(this._pointClouds);

        var intersectedPoints: BABYLON.Vector3[] = [];

        for (var x = 0; x < pointClouds.length; x++) {

            if (pointClouds[x] != null && pointClouds[x] != null && pointClouds[x] != undefined) {
                if (ray.intersectsBoxMinMax(pointClouds[x].mesh.getBoundingInfo().minimum, pointClouds[x].mesh.getBoundingInfo().maximum)) {

                    var positions = pointClouds[x].mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
                    for (var p = 0; p < positions.length; p += 3) {
                        var pos = new BABYLON.Vector3(positions[p], positions[p + 1], positions[p + 2]);
                        var distance = this.distanceRayToPoint(ray, pos);
                        if (distance <= pickTolerance) {
                            intersectedPoints.push(pos);
                        }

                        if (distance <= closeTolerance) {
                            superCloseList.push(pos);
                        }
                    }
                }
            }
        }

        if (superCloseList.length > 0) {
            superCloseList.sort(function (a: BABYLON.Vector3, b: BABYLON.Vector3) {

                if (b == null) {
                    return 1;
                }

                if (a == null) {
                    return -1;
                }

                var d1 = cam.position.subtract(a).length();
                var d2 = cam.position.subtract(b).length();
                if (d1 > d2)
                    return 1;

                else
                    return -1;
            });

            // Since this tests only hit points, make sure there isn't a mesh in front of the picked
            // point.
            

            var validPointPick = true;
            if (meshPick.hit) {
                // check if the hit mesh point is closer to the camera than the super closest.

                var meshDistance = meshPick.pickedPoint.subtract(cam.position).length();
                var pointDistance = superCloseList[0].subtract(cam.position).length();

                if (meshDistance < pointDistance) {
                    // mesh is picked, not points
                    return { point: meshPick.pickedPoint, valid: validPointPick };
                }
            }

            return { point: superCloseList[0], valid: validPointPick };
        }
        intersectedPoints.sort(function (a: BABYLON.Vector3, b: BABYLON.Vector3) {

            if (b == null) {
                return 1;
            }

            if (a == null) {
                return -1;
            }

            var d1 = cam.position.subtract(a).length();
            var d2 = cam.position.subtract(b).length();
            if (d1 > d2)
                return 1;

            else
                return -1;
        });
        if (intersectedPoints.length > 0) {

            var validPointPick = true;
            if (meshPick.hit) {
                // check if the hit mesh point is closer to the camera than the super closest.

                var meshDistance = meshPick.pickedPoint.subtract(cam.position).length();
                var pointDistance = intersectedPoints[0].subtract(cam.position).length();

                if (meshDistance < pointDistance) {
                    // mesh is picked, not points
                    return { point: meshPick.pickedPoint, valid: validPointPick };
                }
            }

            return { point: intersectedPoints[0], valid: validPointPick };
        }
        else if (meshPick.hit) {
            return { point: meshPick.pickedPoint, valid: true };
        }
        else {
            return { point: ray.origin.add(ray.direction.scale(10)), valid:false };
        }
    }

    private isMeshInFrustum(mesh: BABYLON.Mesh, camera: BABYLON.Camera) {
        let boundingInfo = mesh.getBoundingInfo();

        return camera.isInFrustum(boundingInfo);
    }

    private distanceRayToPoint(ray: BABYLON.Ray, point: BABYLON.Vector3) {
        // Calculate the vector from the ray origin to the point
        var originToPoint = point.subtract(ray.origin);

        // Project this vector onto the ray direction
        var rayDirection = ray.direction.normalize();
        var distanceAlongRay = BABYLON.Vector3.Dot(originToPoint, rayDirection);

        // Find the closest point on the ray to the point
        var closestPoint;
        if (distanceAlongRay < 0) {
            // Point is behind the ray's origin
            closestPoint = ray.origin;
        } else {
            closestPoint = ray.origin.add(rayDirection.scale(distanceAlongRay));
        }

        // Check if the distance between the closest point and the point is within the tolerance
        var distance = closestPoint.subtract(point).length();

        return distance;
    }
}

export default PointCloudManager;